import { getAllTestsCount } from "../services/quizService";
export const getQuizTypeCount = (examId) => (dispatch) => {
    getAllTestsCount(examId).then((data) => {
        // handle success
        dispatch({
            type: 'GET_QUIZ_TYPE_COUNT',
            payload: data
        });
    });
};
